import {useIntl} from 'react-intl';
import {PageTitle} from '../../../_metronic/layout/core';
import SuiviConsommationTelHD from '../Components/Telephonie/SuiviConsommationTelHD';

/**
 * Suivi de la consommation téléphonique.
 *
 * Cette page redirigeait auparavant les clients CIS vers l'ancien espace client
 * (`telephonie/consommation`) et affichait « Prochainement disponible » aux autres.
 * Elle porte désormais la maquette de l'écran cible (données fictives en attendant l'API).
 */
const SuiviConsommationPage = (): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'MENU.TELEPHONY.CONSUMPTION'})}
      </PageTitle>
      <SuiviConsommationTelHD />
    </>
  );
};

export default SuiviConsommationPage;
